import React from 'react';
import { Button, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import { Download, Share } from '@insurancemenu/imenu-components-lib/dist/icons';
import { IdsFileLocation } from 'types/pdfService';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import clsx from 'clsx';
import { useRootStore } from 'store/rootStore';
import { createStyles } from './styles';

interface PdfTableRowProps {
  file: IdsFileLocation;
}

const PdfTableRow = ({ file }: PdfTableRowProps): JSX.Element => {
  const classes = createStyles();
  const { id, policyId, pdfLocation, creationDate } = file;
  const {
    readyToSendPdfsStore: { openWarningModal, buildFileLink },
  } = useRootStore();

  const download = (): void => {
    window.open(buildFileLink(id), '_blank');
  };

  const openSendFileModal = (): void => {
    openWarningModal(file);
  };

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={clsx(classes.tableCell, classes.longFileInfo)}>{id}</TableCell>
      <TableCell className={clsx(classes.tableCell, classes.longFileInfo)}>{policyId}</TableCell>
      <TableCell className={clsx(classes.tableCell, classes.longFileInfo)}>{pdfLocation}</TableCell>
      <TableCell className={classes.tableCell}>
        {creationDate ? normDateToShortAmericanDate(creationDate) : ''}
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Button
          type="text"
          leftIconProp={<Share />}
          color="primary"
          onClick={openSendFileModal}
          className={classes.actionButton}
        >
          Send
        </Button>
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Button
          type="text"
          leftIconProp={<Download />}
          color="primary"
          onClick={download}
          className={classes.actionButton}
        >
          Download
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default PdfTableRow;
